export default __webpack_public_path__ + "static/media/logo-menu.8db79d5c.svg";